// src/components/PIIAnonymizerPage/SimplePdfPreviewDialog.jsx
import React, { useEffect, useState } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    IconButton, 
    Typography,
    Box,
    Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SimplePdfPreviewDialog = ({ open, title, fileBlob, onClose, t }) => {
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        if (fileBlob && open) {
            const blob = new Blob([fileBlob], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);

            return () => {
                URL.revokeObjectURL(url);
                setPdfUrl(null);
            };
        }
    }, [fileBlob, open]);

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            fullWidth 
            maxWidth="lg"
            PaperProps={{
                sx: { borderRadius: 3 }
            }}
        >
            <DialogTitle 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    bgcolor: 'background.paper', 
                    py: 2 
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                    {title || 'Náhľad PDF'}
                </Typography>
                <IconButton 
                    onClick={onClose} 
                    size="small"
                    sx={{ bgcolor: 'action.hover', color: 'text.secondary' }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent 
                dividers 
                sx={{ 
                    p: 0, 
                    height: '80vh', 
                    overflow: 'hidden', 
                    bgcolor: 'background.default' 
                }}
            >
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', display: 'block' }}
                        title={title || 'Náhľad PDF'}
                    />
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <Typography color="text.secondary">
                            Dokument nie je k dispozícii
                        </Typography>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default SimplePdfPreviewDialog;